// extracted by mini-css-extract-plugin
export var contrastLow = "_3b-1";
export var externalLink = "_3b-2";
export var externalLinkIcon = "_3b-3";
export var link = "_3b-0";
export var linkLabel = "_3b-4";